<template>
    <div class="panel-card">
        <div class="panel-header">
            <div class="panel-title">
                起草中心
            </div>
            <div class="panel-extra">
                <router-link class="text-link" to="/approval/center">全部模板 &gt;</router-link>
            </div>
        </div>
        <div class="panel-body">
            <div class="template-links">
                <template v-for="item in mergedList">
                    <router-link
                        v-if="item.path"
                        :key="item.title"
                        :class="['template-chip', { 'template-chip-green': item.oftenUse }]"
                        :to="item.path"
                    >
                        <img class="chip-icon" :src="item.oftenUse ? '/index/common.png' : '/index/previous.png'" alt="" />
                        <span class="chip-text">{{ item.title }}</span>
                    </router-link>
                    <a v-else :key="item.title" :class="['template-chip', { 'template-chip-green': item.oftenUse }]">
                        <img class="chip-icon" :src="item.oftenUse ? '/index/common.png' : '/index/previous.png'" alt="" />
                        <span class="chip-text">{{ item.title }}</span>
                    </a>
                </template>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ApprovalDraft',
    computed: {
        mergedList() {
            const key = "often-use-approval";
            const str = window.localStorage.getItem(key);
            let oftenUseList = [];
            if (str) {
                const list = JSON.parse(str);
                list.sort((x, y) => {
                    if (x.count > y.count) {
                        return -1;
                    } else if (x.count < y.count) {
                        return 1;
                    } else {
                        return 0;
                    }
                });
                oftenUseList = list
                    .filter((item, index) => index < 10)
                    .map(item => ({
                        title: item.taskName || item.title,
                        oftenUse: true,
                        path: item.path
                            ? item.path.startsWith("/") ? item.path : "/" + item.path
                            : ""
                    }));
            }
            const paths = new Set(oftenUseList.map(item => item.path));
            const rest = this.templateList.filter(item => !paths.has(item.path));
            return [...oftenUseList, ...rest];
        }
    },
    data() {
        return {
            templateList: [
                {
                    color: "#52C41A",
                    title: "合同金额变更申请",
                    path: "/produce/contract-adjust/add",
                },
                {
                    color: "#52C41A",
                    title: "收入合同审批",
                    path: "/produce/contractRegister/review/add",
                },
                {
                    color: "#52C41A",
                    title: "外部采购类合同审批",
                    path: "/produce/contractRegister/subpackage/add",
                },
                {
                    color: "#52C41A",
                    title: "分支机构外部采购合同审批",
                    path: "/produce/contractRegister/branchSubpackage/add",
                },
                {
                    color: "#52C41A",

                    title: "框架类合同审批",
                    path: "/produce/contractRegister/framework/add",
                },

                {
                    title: "酒水申领审批表",
                    path: "/oa/material/apply",
                },
                {
                    title: "会议室申请审批表",
                    path: "/oa/meeting/add",
                },

                {
                    title: "任务督办单",
                    path: "/oa/supervise/add",
                },

                {
                    title: "档案移交审批表",
                    path: "/oa/archive/query/transfer",
                },

                {
                    title: "档案出借(检索)",
                    path: "/oa/archive/query",
                },
                {
                    title: "开票换票退票审批表",
                    path: "/finance/invoice/apply",
                },
                {
                    title: "渠道备案申请",
                    path: "/market/channelRegistration",
                },
            ]
        }
    }
}
</script>

<style scoped>
.panel-card {
    background: #fff;
    border: 1px solid #eef0f3;
    border-radius: 12px;
}
.panel-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 16px;
    border-bottom: 1px solid #f0f0f0;
}
.panel-title {
    font-size: 18px;
    font-weight: 600;
    color: #1f2937;
    padding-left: 12px;
    /* border-left: 4px solid #2563eb; 删掉原来的border-left */
    position: relative;
}
.panel-title::before {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 4px;
    height: 20px; /* 控制竖线高度，按需修改 */
    background-color: #2563eb;
}
.panel-body {
    padding: 12px 18px 12px;
}
.text-link {
    color: #2563eb;
    cursor: pointer;
    text-decoration: none;
}
.text-link:hover {
    color: #1d4ed8;
}
/* 模板标签 */
.template-links {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
    max-height: calc(24px * 2 + 18px); /* 最多两行：行高 + 间距 */
    overflow: hidden;
}
.template-chip {
    display: inline-flex;
    align-items: center;
    gap: 5px;
    padding: 4px 11px;
    background: #f5f7fa;
    color: #5a6b80;
    border: 1px solid #eef2f7;
    border-radius: 6px;
    font-size: 12px;
    line-height: 1.5;
    text-decoration: none;
    cursor: pointer;
    transition: all .2s;
}
.template-chip:hover {
    background: #eef2f7;
    color: #40536b;
    border-color: #dfe6ee;
}
/* 常用审批标签 */
.template-chip-green {
    background: #eaf1fe;
    color: #2f5286;
    border-color: #dbe7fb;
}
.template-chip-green:hover {
    background: #dbe7fb;
    color: #24447a;
    border-color: #c5d8f7;
}
.template-chip .chip-icon {
    width: 12px;
    height: 12px;
    flex-shrink: 0;
}
.template-chip .chip-text {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
</style>
